<div class="success-receipt">
  <div
    class="modal-background"
    [class.modal-background-success]="!booking.paidDirectly"
    [class.modal-background-warning]="booking.paidDirectly"
  ></div>

  <div class="modal-header">
    <div class="modal-title">{{ 'PICKUP_CONFIRMED' | translate }}</div>

    <button id="closePickupConfirmationModal" type="button" class="close" aria-label="Close" (click)="done()">
      <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <div class="success-icon">
      <div *ngIf="!booking.paidDirectly">
        <svg
          width="70px"
          height="70px"
          viewBox="0 0 70 70"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="Ticket" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Manage-booking-Copy-9" transform="translate(-125.000000, -76.000000)">
              <g id="Group" transform="translate(125.000000, 76.000000)">
                <circle id="Oval-Copy-4" fill="#FFFFFF" cx="35" cy="35" r="35"></circle>
                <image
                  id="Bitmap"
                  x="20"
                  y="25"
                  width="30"
                  height="26"
                  xlink:href="data:image/png;base64,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"
                ></image>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div *ngIf="booking.paidDirectly">
        <svg
          width="70px"
          height="70px"
          viewBox="0 0 70 70"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="Ticket" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Manage-booking-Copy-9" transform="translate(-125.000000, -76.000000)">
              <g id="Group" transform="translate(125.000000, 76.000000)">
                <circle id="Oval-Copy-4" fill="#FFFFFF" cx="35" cy="35" r="35"></circle>
                <image
                  id="Bitmap"
                  x="29"
                  y="16"
                  width="12"
                  height="38"
                  xlink:href="data:image/png;base64,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"
                ></image>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>

    <div class="luggage-image" *ngIf="luggageImage" (click)="showLuggageImage($event)">
      <img [imageName]="luggageImage" imageSize="medium" lhImage />
      <div class="enlarge-cta">
        <div class="icon-container">
          <i class="icon-enlarge"></i>
        </div>
      </div>
    </div>

    <div class="pickup-info" [class.no-luggage-image]="!luggageImage">
      <div>
        <div class="value">{{ booking | booking: 'luggageValue' }}</div>
        <div>{{ booking | booking: 'luggageSuffix' }}</div>
      </div>

      <div>
        <div class="value">{{ booking | booking: 'periodValue' }}</div>
        <div>{{ booking | booking: 'periodSuffix' }}</div>
      </div>
    </div>

    <div class="pickup-time">
      <div class="time">{{ 'PICKUP_TIME' | translate }}</div>
      <div class="date">{{ booking.period.checkOut | lhMoment: 'calendarTime' : booking.timezone }}</div>
    </div>

    <div class="pickup-show-message">
      <p *ngIf="!booking.paidDirectly">{{ 'SHOW_THIS_TO_COLLECT_BAGS_AT' | translate }}</p>
      <p *ngIf="booking.paidDirectly">{{ 'SHOW_THIS_AND_PAY_DIRECTLY_AT' | translate }}</p>
      <div class="shop-name">{{ booking.shopName }}</div>
    </div>

    <div class="pickup-receipt" [class.paid-directly]="booking.paidDirectly">
      <a
        id="showReceipt"
        class="btn btn-link btn-default href"
        [class.btn-lg]="booking.paidDirectly"
        (click)="showReceipt()"
      >
        <span *ngIf="booking.paidDirectly">{{
          booking.price.final.total | price: booking.price.final.currency : 2 : false
        }}</span>
        <span *ngIf="!booking.paidDirectly && !booking.paymentPostponedAt">{{ 'VIEW_RECEIPT' | translate }}</span>
        <span *ngIf="!booking.paidDirectly && booking.paymentPostponedAt">{{ 'GO_TO_PAYMENT' | translate }}</span>
      </a>
    </div>
  </div>
</div>
